import { render, staticRenderFns } from "./AppProposal.vue?vue&type=template&id=d4880cda"
import script from "./AppProposal.vue?vue&type=script&lang=js"
export * from "./AppProposal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports